import React from "react";
import {connect} from "react-redux";
import {acknowledgeError} from "../../actions/ViewActions";
import ActionButton from "../ActionButton";

const ErrorWindowView = (props) => {

  return (
    <form>
      <div className="fields">
        <p>{props.message}</p>
      </div>
      <div className="buttons">
        <ActionButton label="Submit" onClick={props.acknowledgeError} />
      </div>
    </form>
  )

}

function mapStateToProps(state) {
  return {}
}

const ErrorWindowViewContainer = connect(mapStateToProps, {acknowledgeError})(ErrorWindowView);

export default ErrorWindowViewContainer;